// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/agent.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { Subject } from "./identity_pb.js";

/**
 * @generated from enum gitpod.v1.SupportedModel
 */
export enum SupportedModel {
  /**
   * @generated from enum value: SUPPORTED_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_3_5 = 1;
   */
  SONNET_3_5 = 1,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_3_7 = 2;
   */
  SONNET_3_7 = 2,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_3_7_EXTENDED = 3;
   */
  SONNET_3_7_EXTENDED = 3,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4 = 4;
   */
  SONNET_4 = 4,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_EXTENDED = 5;
   */
  SONNET_4_EXTENDED = 5,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4 = 6;
   */
  OPUS_4 = 6,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_EXTENDED = 7;
   */
  OPUS_4_EXTENDED = 7,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_4O = 10;
   */
  OPENAI_4O = 10,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_4O_MINI = 11;
   */
  OPENAI_4O_MINI = 11,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_O1 = 12;
   */
  OPENAI_O1 = 12,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_O1_MINI = 13;
   */
  OPENAI_O1_MINI = 13,
}
// Retrieve enum metadata with: proto3.getEnumType(SupportedModel)
proto3.util.setEnumType(SupportedModel, "gitpod.v1.SupportedModel", [
  { no: 0, name: "SUPPORTED_MODEL_UNSPECIFIED" },
  { no: 1, name: "SUPPORTED_MODEL_SONNET_3_5" },
  { no: 2, name: "SUPPORTED_MODEL_SONNET_3_7" },
  { no: 3, name: "SUPPORTED_MODEL_SONNET_3_7_EXTENDED" },
  { no: 4, name: "SUPPORTED_MODEL_SONNET_4" },
  { no: 5, name: "SUPPORTED_MODEL_SONNET_4_EXTENDED" },
  { no: 6, name: "SUPPORTED_MODEL_OPUS_4" },
  { no: 7, name: "SUPPORTED_MODEL_OPUS_4_EXTENDED" },
  { no: 10, name: "SUPPORTED_MODEL_OPENAI_4O" },
  { no: 11, name: "SUPPORTED_MODEL_OPENAI_4O_MINI" },
  { no: 12, name: "SUPPORTED_MODEL_OPENAI_O1" },
  { no: 13, name: "SUPPORTED_MODEL_OPENAI_O1_MINI" },
]);

/**
 * @generated from message gitpod.v1.Agent
 */
export class Agent extends Message<Agent> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gitpod.v1.AgentMetadata metadata = 2;
   */
  metadata?: AgentMetadata;

  /**
   * @generated from field: gitpod.v1.AgentSpec spec = 3;
   */
  spec?: AgentSpec;

  constructor(data?: PartialMessage<Agent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Agent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: AgentMetadata },
    { no: 3, name: "spec", kind: "message", T: AgentSpec },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Agent {
    return new Agent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Agent {
    return new Agent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Agent {
    return new Agent().fromJsonString(jsonString, options);
  }

  static equals(a: Agent | PlainMessage<Agent> | undefined, b: Agent | PlainMessage<Agent> | undefined): boolean {
    return proto3.util.equals(Agent, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentMetadata
 */
export class AgentMetadata extends Message<AgentMetadata> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<AgentMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentMetadata {
    return new AgentMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentMetadata {
    return new AgentMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentMetadata {
    return new AgentMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: AgentMetadata | PlainMessage<AgentMetadata> | undefined, b: AgentMetadata | PlainMessage<AgentMetadata> | undefined): boolean {
    return proto3.util.equals(AgentMetadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentsRequest
 */
export class ListAgentsRequest extends Message<ListAgentsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListAgentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentsRequest {
    return new ListAgentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentsRequest {
    return new ListAgentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentsRequest {
    return new ListAgentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentsRequest | PlainMessage<ListAgentsRequest> | undefined, b: ListAgentsRequest | PlainMessage<ListAgentsRequest> | undefined): boolean {
    return proto3.util.equals(ListAgentsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentsResponse
 */
export class ListAgentsResponse extends Message<ListAgentsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Agent agents = 2;
   */
  agents: Agent[] = [];

  constructor(data?: PartialMessage<ListAgentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "agents", kind: "message", T: Agent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentsResponse {
    return new ListAgentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentsResponse {
    return new ListAgentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentsResponse {
    return new ListAgentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentsResponse | PlainMessage<ListAgentsResponse> | undefined, b: ListAgentsResponse | PlainMessage<ListAgentsResponse> | undefined): boolean {
    return proto3.util.equals(ListAgentsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAgentRequest
 */
export class GetAgentRequest extends Message<GetAgentRequest> {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  constructor(data?: PartialMessage<GetAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentRequest {
    return new GetAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentRequest {
    return new GetAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentRequest {
    return new GetAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentRequest | PlainMessage<GetAgentRequest> | undefined, b: GetAgentRequest | PlainMessage<GetAgentRequest> | undefined): boolean {
    return proto3.util.equals(GetAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAgentResponse
 */
export class GetAgentResponse extends Message<GetAgentResponse> {
  /**
   * @generated from field: gitpod.v1.Agent agent = 1;
   */
  agent?: Agent;

  constructor(data?: PartialMessage<GetAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent", kind: "message", T: Agent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentResponse {
    return new GetAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentResponse {
    return new GetAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentResponse {
    return new GetAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentResponse | PlainMessage<GetAgentResponse> | undefined, b: GetAgentResponse | PlainMessage<GetAgentResponse> | undefined): boolean {
    return proto3.util.equals(GetAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentCodeContext
 */
export class AgentCodeContext extends Message<AgentCodeContext> {
  /**
   * @generated from oneof gitpod.v1.AgentCodeContext.context
   */
  context: {
    /**
     * @generated from field: string project_id = 1;
     */
    value: string;
    case: "projectId";
  } | {
    /**
     * @generated from field: string environment_id = 2;
     */
    value: string;
    case: "environmentId";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentCodeContext.ContextURL context_url = 3;
     */
    value: AgentCodeContext_ContextURL;
    case: "contextUrl";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<AgentCodeContext>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentCodeContext";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "context" },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "context" },
    { no: 3, name: "context_url", kind: "message", T: AgentCodeContext_ContextURL, oneof: "context" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentCodeContext {
    return new AgentCodeContext().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentCodeContext {
    return new AgentCodeContext().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentCodeContext {
    return new AgentCodeContext().fromJsonString(jsonString, options);
  }

  static equals(a: AgentCodeContext | PlainMessage<AgentCodeContext> | undefined, b: AgentCodeContext | PlainMessage<AgentCodeContext> | undefined): boolean {
    return proto3.util.equals(AgentCodeContext, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentCodeContext.ContextURL
 */
export class AgentCodeContext_ContextURL extends Message<AgentCodeContext_ContextURL> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: string environment_class_id = 2;
   */
  environmentClassId = "";

  constructor(data?: PartialMessage<AgentCodeContext_ContextURL>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentCodeContext.ContextURL";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentCodeContext_ContextURL {
    return new AgentCodeContext_ContextURL().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentCodeContext_ContextURL {
    return new AgentCodeContext_ContextURL().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentCodeContext_ContextURL {
    return new AgentCodeContext_ContextURL().fromJsonString(jsonString, options);
  }

  static equals(a: AgentCodeContext_ContextURL | PlainMessage<AgentCodeContext_ContextURL> | undefined, b: AgentCodeContext_ContextURL | PlainMessage<AgentCodeContext_ContextURL> | undefined): boolean {
    return proto3.util.equals(AgentCodeContext_ContextURL, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StartAgentRequest
 */
export class StartAgentRequest extends Message<StartAgentRequest> {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  /**
   * @generated from field: gitpod.v1.AgentCodeContext code_context = 2;
   */
  codeContext?: AgentCodeContext;

  constructor(data?: PartialMessage<StartAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StartAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code_context", kind: "message", T: AgentCodeContext },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartAgentRequest {
    return new StartAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartAgentRequest {
    return new StartAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartAgentRequest {
    return new StartAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartAgentRequest | PlainMessage<StartAgentRequest> | undefined, b: StartAgentRequest | PlainMessage<StartAgentRequest> | undefined): boolean {
    return proto3.util.equals(StartAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StartAgentResponse
 */
export class StartAgentResponse extends Message<StartAgentResponse> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<StartAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StartAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartAgentResponse {
    return new StartAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartAgentResponse {
    return new StartAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartAgentResponse {
    return new StartAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartAgentResponse | PlainMessage<StartAgentResponse> | undefined, b: StartAgentResponse | PlainMessage<StartAgentResponse> | undefined): boolean {
    return proto3.util.equals(StartAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentExecutionsRequest
 */
export class ListAgentExecutionsRequest extends Message<ListAgentExecutionsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListAgentExecutionsRequest.Filter filter = 2;
   */
  filter?: ListAgentExecutionsRequest_Filter;

  constructor(data?: PartialMessage<ListAgentExecutionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentExecutionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListAgentExecutionsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentExecutionsRequest {
    return new ListAgentExecutionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentExecutionsRequest {
    return new ListAgentExecutionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentExecutionsRequest {
    return new ListAgentExecutionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentExecutionsRequest | PlainMessage<ListAgentExecutionsRequest> | undefined, b: ListAgentExecutionsRequest | PlainMessage<ListAgentExecutionsRequest> | undefined): boolean {
    return proto3.util.equals(ListAgentExecutionsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentExecutionsRequest.Filter
 */
export class ListAgentExecutionsRequest_Filter extends Message<ListAgentExecutionsRequest_Filter> {
  /**
   * @generated from field: repeated string agent_ids = 1;
   */
  agentIds: string[] = [];

  /**
   * @generated from field: repeated string project_ids = 2;
   */
  projectIds: string[] = [];

  /**
   * @generated from field: repeated string environment_ids = 3;
   */
  environmentIds: string[] = [];

  /**
   * @generated from field: repeated string creator_ids = 4;
   */
  creatorIds: string[] = [];

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.Phase status_phases = 5;
   */
  statusPhases: AgentExecution_Phase[] = [];

  constructor(data?: PartialMessage<ListAgentExecutionsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentExecutionsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "environment_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "creator_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "status_phases", kind: "enum", T: proto3.getEnumType(AgentExecution_Phase), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentExecutionsRequest_Filter {
    return new ListAgentExecutionsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentExecutionsRequest_Filter {
    return new ListAgentExecutionsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentExecutionsRequest_Filter {
    return new ListAgentExecutionsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentExecutionsRequest_Filter | PlainMessage<ListAgentExecutionsRequest_Filter> | undefined, b: ListAgentExecutionsRequest_Filter | PlainMessage<ListAgentExecutionsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListAgentExecutionsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentExecutionsResponse
 */
export class ListAgentExecutionsResponse extends Message<ListAgentExecutionsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution agent_executions = 2;
   */
  agentExecutions: AgentExecution[] = [];

  constructor(data?: PartialMessage<ListAgentExecutionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentExecutionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "agent_executions", kind: "message", T: AgentExecution, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentExecutionsResponse {
    return new ListAgentExecutionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentExecutionsResponse {
    return new ListAgentExecutionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentExecutionsResponse {
    return new ListAgentExecutionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentExecutionsResponse | PlainMessage<ListAgentExecutionsResponse> | undefined, b: ListAgentExecutionsResponse | PlainMessage<ListAgentExecutionsResponse> | undefined): boolean {
    return proto3.util.equals(ListAgentExecutionsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAgentExecutionRequest
 */
export class GetAgentExecutionRequest extends Message<GetAgentExecutionRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<GetAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentExecutionRequest {
    return new GetAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentExecutionRequest {
    return new GetAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentExecutionRequest {
    return new GetAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentExecutionRequest | PlainMessage<GetAgentExecutionRequest> | undefined, b: GetAgentExecutionRequest | PlainMessage<GetAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(GetAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAgentExecutionResponse
 */
export class GetAgentExecutionResponse extends Message<GetAgentExecutionResponse> {
  /**
   * @generated from field: gitpod.v1.AgentExecution agent_execution = 1;
   */
  agentExecution?: AgentExecution;

  constructor(data?: PartialMessage<GetAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution", kind: "message", T: AgentExecution },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentExecutionResponse {
    return new GetAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentExecutionResponse {
    return new GetAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentExecutionResponse {
    return new GetAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentExecutionResponse | PlainMessage<GetAgentExecutionResponse> | undefined, b: GetAgentExecutionResponse | PlainMessage<GetAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(GetAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteAgentExecutionRequest
 */
export class DeleteAgentExecutionRequest extends Message<DeleteAgentExecutionRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<DeleteAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAgentExecutionRequest {
    return new DeleteAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAgentExecutionRequest {
    return new DeleteAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAgentExecutionRequest {
    return new DeleteAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAgentExecutionRequest | PlainMessage<DeleteAgentExecutionRequest> | undefined, b: DeleteAgentExecutionRequest | PlainMessage<DeleteAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteAgentExecutionResponse
 */
export class DeleteAgentExecutionResponse extends Message<DeleteAgentExecutionResponse> {
  constructor(data?: PartialMessage<DeleteAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAgentExecutionResponse {
    return new DeleteAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAgentExecutionResponse {
    return new DeleteAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAgentExecutionResponse {
    return new DeleteAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAgentExecutionResponse | PlainMessage<DeleteAgentExecutionResponse> | undefined, b: DeleteAgentExecutionResponse | PlainMessage<DeleteAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(DeleteAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution
 */
export class AgentExecution extends Message<AgentExecution> {
  /**
   * ID is a unique identifier of this agent run. No other agent run with the
   * same name must be managed by this agent manager
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Metadata is data associated with this agent that's required for other
   * parts of Gitpod to function
   *
   * @generated from field: gitpod.v1.AgentExecution.Metadata metadata = 2;
   */
  metadata?: AgentExecution_Metadata;

  /**
   * Spec is the configuration of the agent that's required for the
   * runner to start the agent
   *
   * @generated from field: gitpod.v1.AgentExecution.Spec spec = 3;
   */
  spec?: AgentExecution_Spec;

  /**
   * Status is the current status of the agent
   *
   * @generated from field: gitpod.v1.AgentExecution.Status status = 4;
   */
  status?: AgentExecution_Status;

  constructor(data?: PartialMessage<AgentExecution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: AgentExecution_Metadata },
    { no: 3, name: "spec", kind: "message", T: AgentExecution_Spec },
    { no: 4, name: "status", kind: "message", T: AgentExecution_Status },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution {
    return new AgentExecution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution {
    return new AgentExecution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution {
    return new AgentExecution().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution | PlainMessage<AgentExecution> | undefined, b: AgentExecution | PlainMessage<AgentExecution> | undefined): boolean {
    return proto3.util.equals(AgentExecution, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentExecution.Phase
 */
export enum AgentExecution_Phase {
  /**
   * The phase is not set.
   *
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The agent run is pending.
   *
   * @generated from enum value: PHASE_PENDING = 10;
   */
  PENDING = 10,

  /**
   * The agent run is active.
   *
   * @generated from enum value: PHASE_RUNNING = 20;
   */
  RUNNING = 20,

  /**
   * The agent run is waiting for input.
   *
   * @generated from enum value: PHASE_WAITING_FOR_INPUT = 30;
   */
  WAITING_FOR_INPUT = 30,

  /**
   * The agent run is inactive.
   *
   * @generated from enum value: PHASE_STOPPED = 40;
   */
  STOPPED = 40,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentExecution_Phase)
proto3.util.setEnumType(AgentExecution_Phase, "gitpod.v1.AgentExecution.Phase", [
  { no: 0, name: "PHASE_UNSPECIFIED" },
  { no: 10, name: "PHASE_PENDING" },
  { no: 20, name: "PHASE_RUNNING" },
  { no: 30, name: "PHASE_WAITING_FOR_INPUT" },
  { no: 40, name: "PHASE_STOPPED" },
]);

/**
 * @generated from message gitpod.v1.AgentExecution.Metadata
 */
export class AgentExecution_Metadata extends Message<AgentExecution_Metadata> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: gitpod.v1.Subject creator = 3;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<AgentExecution_Metadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Metadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "creator", kind: "message", T: Subject },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Metadata {
    return new AgentExecution_Metadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Metadata {
    return new AgentExecution_Metadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Metadata {
    return new AgentExecution_Metadata().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Metadata | PlainMessage<AgentExecution_Metadata> | undefined, b: AgentExecution_Metadata | PlainMessage<AgentExecution_Metadata> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Metadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Spec
 */
export class AgentExecution_Spec extends Message<AgentExecution_Spec> {
  /**
   * version of the spec. The value of this field has no semantic
   * meaning (e.g. don't interpret it as as a timestamp),
   * but it can be used to impose a partial order. If a.spec_version <
   * b.spec_version then a was the spec before b.
   *
   * @generated from field: uint64 spec_version = 1;
   */
  specVersion = protoInt64.zero;

  /**
   * @generated from field: string session = 2;
   */
  session = "";

  /**
   * desired_phase is the desired phase of the agent run
   *
   * @generated from field: gitpod.v1.AgentExecution.Phase desired_phase = 3;
   */
  desiredPhase = AgentExecution_Phase.UNSPECIFIED;

  /**
   * @generated from field: string agent_id = 4;
   */
  agentId = "";

  /**
   * @generated from field: gitpod.v1.AgentCodeContext code_context = 5;
   */
  codeContext?: AgentCodeContext;

  /**
   * @generated from field: gitpod.v1.AgentExecution.Spec.Limits limits = 6;
   */
  limits?: AgentExecution_Spec_Limits;

  constructor(data?: PartialMessage<AgentExecution_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "spec_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "desired_phase", kind: "enum", T: proto3.getEnumType(AgentExecution_Phase) },
    { no: 4, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "code_context", kind: "message", T: AgentCodeContext },
    { no: 6, name: "limits", kind: "message", T: AgentExecution_Spec_Limits },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Spec {
    return new AgentExecution_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Spec {
    return new AgentExecution_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Spec {
    return new AgentExecution_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Spec | PlainMessage<AgentExecution_Spec> | undefined, b: AgentExecution_Spec | PlainMessage<AgentExecution_Spec> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Spec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Spec.Limits
 */
export class AgentExecution_Spec_Limits extends Message<AgentExecution_Spec_Limits> {
  /**
   * @generated from field: int64 max_iterations = 1;
   */
  maxIterations = protoInt64.zero;

  /**
   * @generated from field: int64 max_output_tokens = 2;
   */
  maxOutputTokens = protoInt64.zero;

  /**
   * @generated from field: int64 max_input_tokens = 3;
   */
  maxInputTokens = protoInt64.zero;

  constructor(data?: PartialMessage<AgentExecution_Spec_Limits>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Spec.Limits";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "max_iterations", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "max_output_tokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "max_input_tokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Spec_Limits {
    return new AgentExecution_Spec_Limits().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Spec_Limits {
    return new AgentExecution_Spec_Limits().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Spec_Limits {
    return new AgentExecution_Spec_Limits().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Spec_Limits | PlainMessage<AgentExecution_Spec_Limits> | undefined, b: AgentExecution_Spec_Limits | PlainMessage<AgentExecution_Spec_Limits> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Spec_Limits, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status
 */
export class AgentExecution_Status extends Message<AgentExecution_Status> {
  /**
   * version of the status. The value of this field has no semantic
   * meaning (e.g. don't interpret it as as a timestamp),
   * but it can be used to impose a partial order. If a.status_version <
   * b.status_version then a was the status before b.
   *
   * @generated from field: uint64 status_version = 1;
   */
  statusVersion = protoInt64.zero;

  /**
   * @generated from field: string session = 2;
   */
  session = "";

  /**
   * @generated from field: gitpod.v1.AgentExecution.Phase phase = 3;
   */
  phase = AgentExecution_Phase.UNSPECIFIED;

  /**
   * failure_message contains the reason the agent run failed to operate.
   *
   * @generated from field: string failure_message = 4;
   */
  failureMessage = "";

  /**
   * warning_message contains warnings, e.g. when the LLM is overloaded.
   *
   * @generated from field: string warning_message = 5;
   */
  warningMessage = "";

  /**
   * conversation_url is the URL to the conversation (all messages exchanged between the agent and the user) of the agent run.
   *
   * @generated from field: string conversation_url = 10;
   */
  conversationUrl = "";

  /**
   * transcript_url is the URL to the LLM transcript (all messages exchanged between the agent and the LLM) of the agent run.
   *
   * @generated from field: string transcript_url = 11;
   */
  transcriptUrl = "";

  /**
   * @generated from field: int64 iterations = 20;
   */
  iterations = protoInt64.zero;

  /**
   * @generated from field: int64 input_tokens_used = 21;
   */
  inputTokensUsed = protoInt64.zero;

  /**
   * @generated from field: int64 output_tokens_used = 22;
   */
  outputTokensUsed = protoInt64.zero;

  /**
   * @generated from field: int64 context_window_length = 23;
   */
  contextWindowLength = protoInt64.zero;

  /**
   * judgement is the judgement of the agent run produced by the judgement prompt.
   *
   * @generated from field: string judgement = 30;
   */
  judgement = "";

  /**
   * current_operation is the current operation of the agent execution.
   *
   * @generated from field: gitpod.v1.AgentExecution.Status.CurrentOperation current_operation = 40;
   */
  currentOperation?: AgentExecution_Status_CurrentOperation;

  /**
   * used_environments is the list of environments that were used by the agent execution.
   *
   * @generated from field: repeated gitpod.v1.AgentExecution.Status.EnvironmentUsage used_environments = 50;
   */
  usedEnvironments: AgentExecution_Status_EnvironmentUsage[] = [];

  constructor(data?: PartialMessage<AgentExecution_Status>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "phase", kind: "enum", T: proto3.getEnumType(AgentExecution_Phase) },
    { no: 4, name: "failure_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "warning_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "conversation_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "transcript_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "iterations", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "input_tokens_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 22, name: "output_tokens_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 23, name: "context_window_length", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 30, name: "judgement", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "current_operation", kind: "message", T: AgentExecution_Status_CurrentOperation },
    { no: 50, name: "used_environments", kind: "message", T: AgentExecution_Status_EnvironmentUsage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status {
    return new AgentExecution_Status().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status {
    return new AgentExecution_Status().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status {
    return new AgentExecution_Status().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status | PlainMessage<AgentExecution_Status> | undefined, b: AgentExecution_Status | PlainMessage<AgentExecution_Status> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.ToolUse
 */
export class AgentExecution_Status_ToolUse extends Message<AgentExecution_Status_ToolUse> {
  /**
   * @generated from field: string tool_name = 1;
   */
  toolName = "";

  /**
   * @generated from field: bool complete = 2;
   */
  complete = false;

  constructor(data?: PartialMessage<AgentExecution_Status_ToolUse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.ToolUse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tool_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_ToolUse {
    return new AgentExecution_Status_ToolUse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_ToolUse {
    return new AgentExecution_Status_ToolUse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_ToolUse {
    return new AgentExecution_Status_ToolUse().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_ToolUse | PlainMessage<AgentExecution_Status_ToolUse> | undefined, b: AgentExecution_Status_ToolUse | PlainMessage<AgentExecution_Status_ToolUse> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_ToolUse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.LLM
 */
export class AgentExecution_Status_LLM extends Message<AgentExecution_Status_LLM> {
  /**
   * @generated from field: bool complete = 1;
   */
  complete = false;

  constructor(data?: PartialMessage<AgentExecution_Status_LLM>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.LLM";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_LLM {
    return new AgentExecution_Status_LLM().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_LLM {
    return new AgentExecution_Status_LLM().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_LLM {
    return new AgentExecution_Status_LLM().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_LLM | PlainMessage<AgentExecution_Status_LLM> | undefined, b: AgentExecution_Status_LLM | PlainMessage<AgentExecution_Status_LLM> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_LLM, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.CurrentOperation
 */
export class AgentExecution_Status_CurrentOperation extends Message<AgentExecution_Status_CurrentOperation> {
  /**
   * @generated from field: string session = 1;
   */
  session = "";

  /**
   * retries is the number of times the agent run has retried one or more steps
   *
   * @generated from field: int64 retries = 2;
   */
  retries = protoInt64.zero;

  /**
   * @generated from oneof gitpod.v1.AgentExecution.Status.CurrentOperation.operation
   */
  operation: {
    /**
     * @generated from field: gitpod.v1.AgentExecution.Status.ToolUse tool_use = 3;
     */
    value: AgentExecution_Status_ToolUse;
    case: "toolUse";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentExecution.Status.LLM llm = 4;
     */
    value: AgentExecution_Status_LLM;
    case: "llm";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<AgentExecution_Status_CurrentOperation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.CurrentOperation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "retries", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "tool_use", kind: "message", T: AgentExecution_Status_ToolUse, oneof: "operation" },
    { no: 4, name: "llm", kind: "message", T: AgentExecution_Status_LLM, oneof: "operation" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_CurrentOperation {
    return new AgentExecution_Status_CurrentOperation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_CurrentOperation {
    return new AgentExecution_Status_CurrentOperation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_CurrentOperation {
    return new AgentExecution_Status_CurrentOperation().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_CurrentOperation | PlainMessage<AgentExecution_Status_CurrentOperation> | undefined, b: AgentExecution_Status_CurrentOperation | PlainMessage<AgentExecution_Status_CurrentOperation> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_CurrentOperation, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.EnvironmentUsage
 */
export class AgentExecution_Status_EnvironmentUsage extends Message<AgentExecution_Status_EnvironmentUsage> {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId = "";

  /**
   * @generated from field: bool created_by_agent = 2;
   */
  createdByAgent = false;

  constructor(data?: PartialMessage<AgentExecution_Status_EnvironmentUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.EnvironmentUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_by_agent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_EnvironmentUsage {
    return new AgentExecution_Status_EnvironmentUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_EnvironmentUsage {
    return new AgentExecution_Status_EnvironmentUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_EnvironmentUsage {
    return new AgentExecution_Status_EnvironmentUsage().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_EnvironmentUsage | PlainMessage<AgentExecution_Status_EnvironmentUsage> | undefined, b: AgentExecution_Status_EnvironmentUsage | PlainMessage<AgentExecution_Status_EnvironmentUsage> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_EnvironmentUsage, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock
 */
export class AgentResponseBlock extends Message<AgentResponseBlock> {
  /**
   * id is the unique identifier of the response block. A conversation can have multiple blocks with the same ID.
   * Clients are expected to use the ID to update or replace a block.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * phase is the phase of the response block indicating how to update the previous output block with the same ID.
   *
   * @generated from field: gitpod.v1.AgentResponseBlock.Phase phase = 2;
   */
  phase = AgentResponseBlock_Phase.UNSPECIFIED;

  /**
   * @generated from oneof gitpod.v1.AgentResponseBlock.output
   */
  output: {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.TextOutput text = 10;
     */
    value: AgentResponseBlock_TextOutput;
    case: "text";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.ActionStarted action_started = 20;
     */
    value: AgentResponseBlock_ActionStarted;
    case: "actionStarted";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.ActionCompleted action_completed = 21;
     */
    value: AgentResponseBlock_ActionCompleted;
    case: "actionCompleted";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.FileModification file_modification = 30;
     */
    value: AgentResponseBlock_FileModification;
    case: "fileModification";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.EnvironmentCreation environment_creation = 40;
     */
    value: AgentResponseBlock_EnvironmentCreation;
    case: "environmentCreation";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.CodeAnnotation code_annotation = 50;
     */
    value: AgentResponseBlock_CodeAnnotation;
    case: "codeAnnotation";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.HostAuthenticationRequired host_authentication_required = 60;
     */
    value: AgentResponseBlock_HostAuthenticationRequired;
    case: "hostAuthenticationRequired";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<AgentResponseBlock>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phase", kind: "enum", T: proto3.getEnumType(AgentResponseBlock_Phase) },
    { no: 10, name: "text", kind: "message", T: AgentResponseBlock_TextOutput, oneof: "output" },
    { no: 20, name: "action_started", kind: "message", T: AgentResponseBlock_ActionStarted, oneof: "output" },
    { no: 21, name: "action_completed", kind: "message", T: AgentResponseBlock_ActionCompleted, oneof: "output" },
    { no: 30, name: "file_modification", kind: "message", T: AgentResponseBlock_FileModification, oneof: "output" },
    { no: 40, name: "environment_creation", kind: "message", T: AgentResponseBlock_EnvironmentCreation, oneof: "output" },
    { no: 50, name: "code_annotation", kind: "message", T: AgentResponseBlock_CodeAnnotation, oneof: "output" },
    { no: 60, name: "host_authentication_required", kind: "message", T: AgentResponseBlock_HostAuthenticationRequired, oneof: "output" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock {
    return new AgentResponseBlock().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock {
    return new AgentResponseBlock().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock {
    return new AgentResponseBlock().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock | PlainMessage<AgentResponseBlock> | undefined, b: AgentResponseBlock | PlainMessage<AgentResponseBlock> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.Phase
 */
export enum AgentResponseBlock_Phase {
  /**
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Update replaces the previous output block with the same ID.
   *
   * @generated from enum value: PHASE_UPDATE = 1;
   */
  UPDATE = 1,

  /**
   * Completed indicates that the output block is complete - it overrides any previous output block with the same ID.
   *
   * @generated from enum value: PHASE_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * Delta indicates that the output block is a delta to the previous output block; append to the previous output block.
   *
   * @generated from enum value: PHASE_DELTA = 3;
   */
  DELTA = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentResponseBlock_Phase)
proto3.util.setEnumType(AgentResponseBlock_Phase, "gitpod.v1.AgentResponseBlock.Phase", [
  { no: 0, name: "PHASE_UNSPECIFIED" },
  { no: 1, name: "PHASE_UPDATE" },
  { no: 2, name: "PHASE_COMPLETED" },
  { no: 3, name: "PHASE_DELTA" },
]);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.TextOutput
 */
export class AgentResponseBlock_TextOutput extends Message<AgentResponseBlock_TextOutput> {
  /**
   * @generated from field: gitpod.v1.AgentResponseBlock.TextOutput.Type type = 1;
   */
  type = AgentResponseBlock_TextOutput_Type.UNSPECIFIED;

  /**
   * @generated from field: string content = 2;
   */
  content = "";

  constructor(data?: PartialMessage<AgentResponseBlock_TextOutput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.TextOutput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(AgentResponseBlock_TextOutput_Type) },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_TextOutput {
    return new AgentResponseBlock_TextOutput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_TextOutput {
    return new AgentResponseBlock_TextOutput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_TextOutput {
    return new AgentResponseBlock_TextOutput().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_TextOutput | PlainMessage<AgentResponseBlock_TextOutput> | undefined, b: AgentResponseBlock_TextOutput | PlainMessage<AgentResponseBlock_TextOutput> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_TextOutput, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.TextOutput.Type
 */
export enum AgentResponseBlock_TextOutput_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TYPE_USER_FACING_OUTPUT = 1;
   */
  USER_FACING_OUTPUT = 1,

  /**
   * @generated from enum value: TYPE_THOUGHTS = 2;
   */
  THOUGHTS = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentResponseBlock_TextOutput_Type)
proto3.util.setEnumType(AgentResponseBlock_TextOutput_Type, "gitpod.v1.AgentResponseBlock.TextOutput.Type", [
  { no: 0, name: "TYPE_UNSPECIFIED" },
  { no: 1, name: "TYPE_USER_FACING_OUTPUT" },
  { no: 2, name: "TYPE_THOUGHTS" },
]);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.ActionStarted
 */
export class AgentResponseBlock_ActionStarted extends Message<AgentResponseBlock_ActionStarted> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string intent_description = 2;
   */
  intentDescription = "";

  constructor(data?: PartialMessage<AgentResponseBlock_ActionStarted>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.ActionStarted";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "intent_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_ActionStarted {
    return new AgentResponseBlock_ActionStarted().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_ActionStarted {
    return new AgentResponseBlock_ActionStarted().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_ActionStarted {
    return new AgentResponseBlock_ActionStarted().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_ActionStarted | PlainMessage<AgentResponseBlock_ActionStarted> | undefined, b: AgentResponseBlock_ActionStarted | PlainMessage<AgentResponseBlock_ActionStarted> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_ActionStarted, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.ActionCompleted
 */
export class AgentResponseBlock_ActionCompleted extends Message<AgentResponseBlock_ActionCompleted> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string result_description = 2;
   */
  resultDescription = "";

  /**
   * @generated from field: bool failed = 3;
   */
  failed = false;

  constructor(data?: PartialMessage<AgentResponseBlock_ActionCompleted>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.ActionCompleted";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "result_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "failed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_ActionCompleted {
    return new AgentResponseBlock_ActionCompleted().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_ActionCompleted {
    return new AgentResponseBlock_ActionCompleted().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_ActionCompleted {
    return new AgentResponseBlock_ActionCompleted().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_ActionCompleted | PlainMessage<AgentResponseBlock_ActionCompleted> | undefined, b: AgentResponseBlock_ActionCompleted | PlainMessage<AgentResponseBlock_ActionCompleted> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_ActionCompleted, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.FileModification
 */
export class AgentResponseBlock_FileModification extends Message<AgentResponseBlock_FileModification> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string file_path = 2;
   */
  filePath = "";

  /**
   * @generated from field: string content = 3;
   */
  content = "";

  constructor(data?: PartialMessage<AgentResponseBlock_FileModification>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.FileModification";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_FileModification {
    return new AgentResponseBlock_FileModification().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification {
    return new AgentResponseBlock_FileModification().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification {
    return new AgentResponseBlock_FileModification().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_FileModification | PlainMessage<AgentResponseBlock_FileModification> | undefined, b: AgentResponseBlock_FileModification | PlainMessage<AgentResponseBlock_FileModification> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_FileModification, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.EnvironmentCreation
 */
export class AgentResponseBlock_EnvironmentCreation extends Message<AgentResponseBlock_EnvironmentCreation> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId = "";

  constructor(data?: PartialMessage<AgentResponseBlock_EnvironmentCreation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.EnvironmentCreation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_EnvironmentCreation {
    return new AgentResponseBlock_EnvironmentCreation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_EnvironmentCreation {
    return new AgentResponseBlock_EnvironmentCreation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_EnvironmentCreation {
    return new AgentResponseBlock_EnvironmentCreation().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_EnvironmentCreation | PlainMessage<AgentResponseBlock_EnvironmentCreation> | undefined, b: AgentResponseBlock_EnvironmentCreation | PlainMessage<AgentResponseBlock_EnvironmentCreation> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_EnvironmentCreation, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.HostAuthenticationRequired
 */
export class AgentResponseBlock_HostAuthenticationRequired extends Message<AgentResponseBlock_HostAuthenticationRequired> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string host = 2;
   */
  host = "";

  /**
   * @generated from field: string runner_id = 3;
   */
  runnerId = "";

  constructor(data?: PartialMessage<AgentResponseBlock_HostAuthenticationRequired>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.HostAuthenticationRequired";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_HostAuthenticationRequired {
    return new AgentResponseBlock_HostAuthenticationRequired().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_HostAuthenticationRequired {
    return new AgentResponseBlock_HostAuthenticationRequired().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_HostAuthenticationRequired {
    return new AgentResponseBlock_HostAuthenticationRequired().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_HostAuthenticationRequired | PlainMessage<AgentResponseBlock_HostAuthenticationRequired> | undefined, b: AgentResponseBlock_HostAuthenticationRequired | PlainMessage<AgentResponseBlock_HostAuthenticationRequired> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_HostAuthenticationRequired, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.CodeAnnotation
 */
export class AgentResponseBlock_CodeAnnotation extends Message<AgentResponseBlock_CodeAnnotation> {
  /**
   * @generated from field: string file_path = 1;
   */
  filePath = "";

  /**
   * @generated from field: int32 start_line = 2;
   */
  startLine = 0;

  /**
   * @generated from field: int32 end_line = 3;
   */
  endLine = 0;

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  constructor(data?: PartialMessage<AgentResponseBlock_CodeAnnotation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.CodeAnnotation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "end_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_CodeAnnotation {
    return new AgentResponseBlock_CodeAnnotation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_CodeAnnotation {
    return new AgentResponseBlock_CodeAnnotation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_CodeAnnotation {
    return new AgentResponseBlock_CodeAnnotation().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_CodeAnnotation | PlainMessage<AgentResponseBlock_CodeAnnotation> | undefined, b: AgentResponseBlock_CodeAnnotation | PlainMessage<AgentResponseBlock_CodeAnnotation> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_CodeAnnotation, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UserInputBlock
 */
export class UserInputBlock extends Message<UserInputBlock> {
  /**
   * @generated from oneof gitpod.v1.UserInputBlock.input
   */
  input: {
    /**
     * @generated from field: gitpod.v1.UserInputBlock.TextInput text = 20;
     */
    value: UserInputBlock_TextInput;
    case: "text";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<UserInputBlock>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UserInputBlock";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 20, name: "text", kind: "message", T: UserInputBlock_TextInput, oneof: "input" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserInputBlock {
    return new UserInputBlock().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserInputBlock {
    return new UserInputBlock().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserInputBlock {
    return new UserInputBlock().fromJsonString(jsonString, options);
  }

  static equals(a: UserInputBlock | PlainMessage<UserInputBlock> | undefined, b: UserInputBlock | PlainMessage<UserInputBlock> | undefined): boolean {
    return proto3.util.equals(UserInputBlock, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UserInputBlock.TextInput
 */
export class UserInputBlock_TextInput extends Message<UserInputBlock_TextInput> {
  /**
   * @generated from field: string content = 1;
   */
  content = "";

  constructor(data?: PartialMessage<UserInputBlock_TextInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UserInputBlock.TextInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserInputBlock_TextInput {
    return new UserInputBlock_TextInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserInputBlock_TextInput {
    return new UserInputBlock_TextInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserInputBlock_TextInput {
    return new UserInputBlock_TextInput().fromJsonString(jsonString, options);
  }

  static equals(a: UserInputBlock_TextInput | PlainMessage<UserInputBlock_TextInput> | undefined, b: UserInputBlock_TextInput | PlainMessage<UserInputBlock_TextInput> | undefined): boolean {
    return proto3.util.equals(UserInputBlock_TextInput, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SendToAgentExecutionRequest
 */
export class SendToAgentExecutionRequest extends Message<SendToAgentExecutionRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  /**
   * @generated from field: gitpod.v1.UserInputBlock user_input = 2;
   */
  userInput?: UserInputBlock;

  constructor(data?: PartialMessage<SendToAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SendToAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_input", kind: "message", T: UserInputBlock },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendToAgentExecutionRequest {
    return new SendToAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendToAgentExecutionRequest {
    return new SendToAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendToAgentExecutionRequest {
    return new SendToAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendToAgentExecutionRequest | PlainMessage<SendToAgentExecutionRequest> | undefined, b: SendToAgentExecutionRequest | PlainMessage<SendToAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(SendToAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SendToAgentExecutionResponse
 */
export class SendToAgentExecutionResponse extends Message<SendToAgentExecutionResponse> {
  constructor(data?: PartialMessage<SendToAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SendToAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendToAgentExecutionResponse {
    return new SendToAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendToAgentExecutionResponse {
    return new SendToAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendToAgentExecutionResponse {
    return new SendToAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendToAgentExecutionResponse | PlainMessage<SendToAgentExecutionResponse> | undefined, b: SendToAgentExecutionResponse | PlainMessage<SendToAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(SendToAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentExecutionConversationTokenRequest
 */
export class CreateAgentExecutionConversationTokenRequest extends Message<CreateAgentExecutionConversationTokenRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<CreateAgentExecutionConversationTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentExecutionConversationTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentExecutionConversationTokenRequest {
    return new CreateAgentExecutionConversationTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentExecutionConversationTokenRequest {
    return new CreateAgentExecutionConversationTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentExecutionConversationTokenRequest {
    return new CreateAgentExecutionConversationTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentExecutionConversationTokenRequest | PlainMessage<CreateAgentExecutionConversationTokenRequest> | undefined, b: CreateAgentExecutionConversationTokenRequest | PlainMessage<CreateAgentExecutionConversationTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateAgentExecutionConversationTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentExecutionConversationTokenResponse
 */
export class CreateAgentExecutionConversationTokenResponse extends Message<CreateAgentExecutionConversationTokenResponse> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<CreateAgentExecutionConversationTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentExecutionConversationTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentExecutionConversationTokenResponse {
    return new CreateAgentExecutionConversationTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentExecutionConversationTokenResponse {
    return new CreateAgentExecutionConversationTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentExecutionConversationTokenResponse {
    return new CreateAgentExecutionConversationTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentExecutionConversationTokenResponse | PlainMessage<CreateAgentExecutionConversationTokenResponse> | undefined, b: CreateAgentExecutionConversationTokenResponse | PlainMessage<CreateAgentExecutionConversationTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateAgentExecutionConversationTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentExecutionTranscriptTokenRequest
 */
export class CreateAgentExecutionTranscriptTokenRequest extends Message<CreateAgentExecutionTranscriptTokenRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<CreateAgentExecutionTranscriptTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentExecutionTranscriptTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentExecutionTranscriptTokenRequest {
    return new CreateAgentExecutionTranscriptTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentExecutionTranscriptTokenRequest {
    return new CreateAgentExecutionTranscriptTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentExecutionTranscriptTokenRequest {
    return new CreateAgentExecutionTranscriptTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentExecutionTranscriptTokenRequest | PlainMessage<CreateAgentExecutionTranscriptTokenRequest> | undefined, b: CreateAgentExecutionTranscriptTokenRequest | PlainMessage<CreateAgentExecutionTranscriptTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateAgentExecutionTranscriptTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentExecutionTranscriptTokenResponse
 */
export class CreateAgentExecutionTranscriptTokenResponse extends Message<CreateAgentExecutionTranscriptTokenResponse> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<CreateAgentExecutionTranscriptTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentExecutionTranscriptTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentExecutionTranscriptTokenResponse {
    return new CreateAgentExecutionTranscriptTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentExecutionTranscriptTokenResponse {
    return new CreateAgentExecutionTranscriptTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentExecutionTranscriptTokenResponse {
    return new CreateAgentExecutionTranscriptTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentExecutionTranscriptTokenResponse | PlainMessage<CreateAgentExecutionTranscriptTokenResponse> | undefined, b: CreateAgentExecutionTranscriptTokenResponse | PlainMessage<CreateAgentExecutionTranscriptTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateAgentExecutionTranscriptTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentSpec
 */
export class AgentSpec extends Message<AgentSpec> {
  /**
   * The prompts configuration for each supported model. One cannot have multiple prompts for the same model - this will return an invalid argument error.
   *
   * @generated from field: repeated gitpod.v1.AgentSpec.Prompts prompts = 1;
   */
  prompts: AgentSpec_Prompts[] = [];

  /**
   * The list of tools required by this agent to function
   *
   * @generated from field: repeated string required_tools = 2;
   */
  requiredTools: string[] = [];

  constructor(data?: PartialMessage<AgentSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompts", kind: "message", T: AgentSpec_Prompts, repeated: true },
    { no: 2, name: "required_tools", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentSpec {
    return new AgentSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentSpec {
    return new AgentSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentSpec {
    return new AgentSpec().fromJsonString(jsonString, options);
  }

  static equals(a: AgentSpec | PlainMessage<AgentSpec> | undefined, b: AgentSpec | PlainMessage<AgentSpec> | undefined): boolean {
    return proto3.util.equals(AgentSpec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentSpec.Prompts
 */
export class AgentSpec_Prompts extends Message<AgentSpec_Prompts> {
  /**
   * The model these prompts are for
   *
   * @generated from field: gitpod.v1.SupportedModel model = 1;
   */
  model = SupportedModel.UNSPECIFIED;

  /**
   * The system prompt that defines the agent's role and capabilities
   *
   * @generated from field: string system_prompt = 2;
   */
  systemPrompt = "";

  /**
   * The initial message sent to the user. If empty, the agent will start in WAITING_FOR_INPUT state
   *
   * @generated from field: string initial_message = 3;
   */
  initialMessage = "";

  /**
   * The prompt used to evaluate agent's performance and provide final assessment
   *
   * @generated from field: string judgement_prompt = 4;
   */
  judgementPrompt = "";

  /**
   * The prompt used to improve the agent's prompt
   *
   * @generated from field: string improve_prompt = 5;
   */
  improvePrompt = "";

  constructor(data?: PartialMessage<AgentSpec_Prompts>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentSpec.Prompts";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "enum", T: proto3.getEnumType(SupportedModel) },
    { no: 2, name: "system_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "initial_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "judgement_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "improve_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentSpec_Prompts {
    return new AgentSpec_Prompts().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentSpec_Prompts {
    return new AgentSpec_Prompts().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentSpec_Prompts {
    return new AgentSpec_Prompts().fromJsonString(jsonString, options);
  }

  static equals(a: AgentSpec_Prompts | PlainMessage<AgentSpec_Prompts> | undefined, b: AgentSpec_Prompts | PlainMessage<AgentSpec_Prompts> | undefined): boolean {
    return proto3.util.equals(AgentSpec_Prompts, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentRequest
 */
export class CreateAgentRequest extends Message<CreateAgentRequest> {
  /**
   * The name of the agent
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * A description of what the agent does
   *
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * The prompts configuration for each supported model
   *
   * @generated from field: gitpod.v1.AgentSpec spec = 4;
   */
  spec?: AgentSpec;

  constructor(data?: PartialMessage<CreateAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "spec", kind: "message", T: AgentSpec },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentRequest {
    return new CreateAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentRequest {
    return new CreateAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentRequest {
    return new CreateAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentRequest | PlainMessage<CreateAgentRequest> | undefined, b: CreateAgentRequest | PlainMessage<CreateAgentRequest> | undefined): boolean {
    return proto3.util.equals(CreateAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentResponse
 */
export class CreateAgentResponse extends Message<CreateAgentResponse> {
  /**
   * The created agent
   *
   * @generated from field: gitpod.v1.Agent agent = 1;
   */
  agent?: Agent;

  constructor(data?: PartialMessage<CreateAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent", kind: "message", T: Agent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentResponse {
    return new CreateAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentResponse {
    return new CreateAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentResponse {
    return new CreateAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentResponse | PlainMessage<CreateAgentResponse> | undefined, b: CreateAgentResponse | PlainMessage<CreateAgentResponse> | undefined): boolean {
    return proto3.util.equals(CreateAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentRequest
 */
export class UpdateAgentRequest extends Message<UpdateAgentRequest> {
  /**
   * The ID of the agent to update
   *
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  /**
   * Optional metadata which will replace the existing metadata partially
   * If not provided, the existing metadata will be kept.
   *
   * @generated from field: gitpod.v1.UpdateAgentRequest.Metadata metadata = 2;
   */
  metadata?: UpdateAgentRequest_Metadata;

  /**
   * Optional spec which will replace the existing spec partially
   *
   * @generated from field: gitpod.v1.UpdateAgentRequest.Spec spec = 3;
   */
  spec?: UpdateAgentRequest_Spec;

  constructor(data?: PartialMessage<UpdateAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: UpdateAgentRequest_Metadata },
    { no: 3, name: "spec", kind: "message", T: UpdateAgentRequest_Spec },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentRequest {
    return new UpdateAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentRequest {
    return new UpdateAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentRequest {
    return new UpdateAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentRequest | PlainMessage<UpdateAgentRequest> | undefined, b: UpdateAgentRequest | PlainMessage<UpdateAgentRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentRequest.Metadata
 */
export class UpdateAgentRequest_Metadata extends Message<UpdateAgentRequest_Metadata> {
  /**
   * The name of the agent
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * A description of what the agent does
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  constructor(data?: PartialMessage<UpdateAgentRequest_Metadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentRequest.Metadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentRequest_Metadata {
    return new UpdateAgentRequest_Metadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentRequest_Metadata {
    return new UpdateAgentRequest_Metadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentRequest_Metadata {
    return new UpdateAgentRequest_Metadata().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentRequest_Metadata | PlainMessage<UpdateAgentRequest_Metadata> | undefined, b: UpdateAgentRequest_Metadata | PlainMessage<UpdateAgentRequest_Metadata> | undefined): boolean {
    return proto3.util.equals(UpdateAgentRequest_Metadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentRequest.Spec
 */
export class UpdateAgentRequest_Spec extends Message<UpdateAgentRequest_Spec> {
  /**
   * The prompts configuration for each supported model.
   * Setting the system prompt of a model to the empty value will remove the system prompt for that model.
   * Adding a prompt for a model that already has a prompt will replace the existing prompt for that model.
   * Adding a prompt for a model that does not exist adds a new prompt for that model.
   *
   * @generated from field: repeated gitpod.v1.AgentSpec.Prompts prompts = 1;
   */
  prompts: AgentSpec_Prompts[] = [];

  /**
   * The list of tools required by this agent to function.
   * Providing a value here will replace the existing list of required tools.
   *
   * @generated from field: repeated string required_tools = 2;
   */
  requiredTools: string[] = [];

  constructor(data?: PartialMessage<UpdateAgentRequest_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentRequest.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompts", kind: "message", T: AgentSpec_Prompts, repeated: true },
    { no: 2, name: "required_tools", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentRequest_Spec {
    return new UpdateAgentRequest_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentRequest_Spec {
    return new UpdateAgentRequest_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentRequest_Spec {
    return new UpdateAgentRequest_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentRequest_Spec | PlainMessage<UpdateAgentRequest_Spec> | undefined, b: UpdateAgentRequest_Spec | PlainMessage<UpdateAgentRequest_Spec> | undefined): boolean {
    return proto3.util.equals(UpdateAgentRequest_Spec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentResponse
 */
export class UpdateAgentResponse extends Message<UpdateAgentResponse> {
  /**
   * The updated agent
   *
   * @generated from field: gitpod.v1.Agent agent = 1;
   */
  agent?: Agent;

  constructor(data?: PartialMessage<UpdateAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent", kind: "message", T: Agent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentResponse {
    return new UpdateAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentResponse {
    return new UpdateAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentResponse {
    return new UpdateAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentResponse | PlainMessage<UpdateAgentResponse> | undefined, b: UpdateAgentResponse | PlainMessage<UpdateAgentResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteAgentRequest
 */
export class DeleteAgentRequest extends Message<DeleteAgentRequest> {
  /**
   * The ID of the agent to delete
   *
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  constructor(data?: PartialMessage<DeleteAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAgentRequest {
    return new DeleteAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAgentRequest {
    return new DeleteAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAgentRequest {
    return new DeleteAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAgentRequest | PlainMessage<DeleteAgentRequest> | undefined, b: DeleteAgentRequest | PlainMessage<DeleteAgentRequest> | undefined): boolean {
    return proto3.util.equals(DeleteAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteAgentResponse
 */
export class DeleteAgentResponse extends Message<DeleteAgentResponse> {
  constructor(data?: PartialMessage<DeleteAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAgentResponse {
    return new DeleteAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAgentResponse {
    return new DeleteAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAgentResponse {
    return new DeleteAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAgentResponse | PlainMessage<DeleteAgentResponse> | undefined, b: DeleteAgentResponse | PlainMessage<DeleteAgentResponse> | undefined): boolean {
    return proto3.util.equals(DeleteAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StopAgentExecutionRequest
 */
export class StopAgentExecutionRequest extends Message<StopAgentExecutionRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<StopAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StopAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StopAgentExecutionRequest {
    return new StopAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StopAgentExecutionRequest {
    return new StopAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StopAgentExecutionRequest {
    return new StopAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StopAgentExecutionRequest | PlainMessage<StopAgentExecutionRequest> | undefined, b: StopAgentExecutionRequest | PlainMessage<StopAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(StopAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StopAgentExecutionResponse
 */
export class StopAgentExecutionResponse extends Message<StopAgentExecutionResponse> {
  constructor(data?: PartialMessage<StopAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StopAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StopAgentExecutionResponse {
    return new StopAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StopAgentExecutionResponse {
    return new StopAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StopAgentExecutionResponse {
    return new StopAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StopAgentExecutionResponse | PlainMessage<StopAgentExecutionResponse> | undefined, b: StopAgentExecutionResponse | PlainMessage<StopAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(StopAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ImprovePromptForAgentRequest
 */
export class ImprovePromptForAgentRequest extends Message<ImprovePromptForAgentRequest> {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  /**
   * @generated from field: string prompt = 2;
   */
  prompt = "";

  constructor(data?: PartialMessage<ImprovePromptForAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ImprovePromptForAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImprovePromptForAgentRequest {
    return new ImprovePromptForAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImprovePromptForAgentRequest {
    return new ImprovePromptForAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImprovePromptForAgentRequest {
    return new ImprovePromptForAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImprovePromptForAgentRequest | PlainMessage<ImprovePromptForAgentRequest> | undefined, b: ImprovePromptForAgentRequest | PlainMessage<ImprovePromptForAgentRequest> | undefined): boolean {
    return proto3.util.equals(ImprovePromptForAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ImprovePromptForAgentResponse
 */
export class ImprovePromptForAgentResponse extends Message<ImprovePromptForAgentResponse> {
  /**
   * @generated from field: string improved_prompt = 1;
   */
  improvedPrompt = "";

  constructor(data?: PartialMessage<ImprovePromptForAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ImprovePromptForAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "improved_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImprovePromptForAgentResponse {
    return new ImprovePromptForAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImprovePromptForAgentResponse {
    return new ImprovePromptForAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImprovePromptForAgentResponse {
    return new ImprovePromptForAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ImprovePromptForAgentResponse | PlainMessage<ImprovePromptForAgentResponse> | undefined, b: ImprovePromptForAgentResponse | PlainMessage<ImprovePromptForAgentResponse> | undefined): boolean {
    return proto3.util.equals(ImprovePromptForAgentResponse, a, b);
  }
}

